import React, { useState, useEffect } from "react";
import "./AdminLogin.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import API_URL from "../../../utils/API_URL";
const AdminLogin = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const handle_change_input = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const [loading, setLoading] = useState(false);

  const handle_submit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const res = await axios.post(`${API_URL}/admin/login`, data);
      if (res.status === 200) {
        localStorage.setItem("token", res.data.data.token);
        toast.success(res.data.message);
        setLoading(false);
        navigate("/adminleads");
      }
    } catch (error) {
      console.log(error);
        setLoading(false);

      console.log("=================== error", error);
      if (error.response) {
        const status = error.response.status;
        if (status === 409) {
          toast.error(error.response.data.message);
        } else if (status === 422) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response.data.message);
        }
      } else {
        alert("Network error. Please try later.");
      }
    }
  };

  useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  return (
    <div className="admin_login_bg">
      <ToastContainer />
      <div class="login-box">
        <h2>Admin Login</h2>
        <form class="form" onSubmit={(e) => handle_submit(e)}>
          <div class="user-box">
            <input
              class="input"
              type="text"
              id=""
              required=""
              name="username"
              onChange={(e) => handle_change_input(e)}
            />
            <label class="label" for="">
              Username
            </label>
          </div>

          <div class="user-box">
            <input
              class="input"
              type="password"
              id=""
              required=""
              name="password"
              onChange={(e) => handle_change_input(e)}
            />
            <label class="label" for="">
              Password
            </label>
          </div>

          <button type="submit" disabled={loading}>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  {loading ? "Submitting..." : "Submit"}
</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
